import React, { useReducer } from "react";
import axios from "axios";
import { Form, Field } from "react-final-form";

import URL, { headers } from "../../common/variables";
import { getUrlParameter } from "../../common/functions";
import { PasswordResetReducer } from "./PasswordResetReducer";
import PasswordResetValidations, {
    PasswordResetConfirmationValidations,
} from "./PasswordResetValidations";

const ShowMessage = ({ text }) => (
    <p className="mt-3 text-white" key={text}>
        {text}
    </p>
);

const ShowErrors = ({ arr }) =>
    arr.map((txt, pos) => (
        <div className="mt-3 text-danger" key={pos}>
            {txt}
        </div>
    ));

const apiErrors = (error) =>
    Object.keys(error.response.data).map((key) => obj[key]);

const PasswordReset = ({ isResetConfirmation }) => {
    let initialState = {
        isReset: true,
        isResetConfirmation: false,
        isError: false,
        isErrorMessage: [],
        isMessage: "",
    };

    if (isResetConfirmation) {
        initialState = { ...initialState, isReset: false, isResetConfirmation };
    }

    const [state, dispatch] = useReducer(PasswordResetReducer, initialState);

    const onSubmitReset = (values) => {
        axios
            .post(`${URL}/rest-auth/password/reset/`, values, { headers })
            .then((response) => {
                dispatch({ type: "IS_ERROR_REMOVED" });
                if (
                    response.data.detail ===
                    "Password reset e-mail has been sent."
                ) {
                    dispatch({
                        type: "SHOW_MESSAGE",
                        message: `Se ha enviado un correo electrónico de restablecimiento de contraseña. 
                      Por favor haz uso de la liga recibida y puedes cerrar esta ventana.`,
                    });
                }
            })
            .catch((error) => {
                if (error.response) {
                    dispatch({
                        type: "IS_ERROR_ACTIVE",
                        message: apiErrors(error),
                    });
                }
            });
    };

    // Query string example: ~/?type=password-reset&uid=MQ&token=5fg-3d71fea89ec32fc26e9b
    const onSubmitResetConformation = (values) => {
        values.uid = getUrlParameter("uid");
        values.token = getUrlParameter("token");

        axios
            .post(`${URL}/rest-auth/password/reset/confirm/`, values, {
                headers,
            })
            .then(() => dispatch({ type: "IS_ERROR_REMOVED" }))
            .catch((error) => {
                if (error.response) {
                    dispatch({
                        type: "IS_ERROR_ACTIVE",
                        message: apiErrors(error),
                    });
                }
            });
    };

    const focusInput = () => {
        dispatch({ type: "IS_ERROR_REMOVED" });
    };

    return (
        <div className="login">
            {state.isReset && (
                <Form
                    onSubmit={onSubmitReset}
                    validate={PasswordResetValidations}
                    render={({ handleSubmit, submitting }) => (
                        <form onSubmit={handleSubmit}>
                            <Field name="email">
                                {({ input, meta }) => (
                                    <div>
                                        <input
                                            {...input}
                                            autoComplete="off"
                                            className="form-control rounded-0"
                                            onFocus={focusInput}
                                            placeholder="Correo electrónico"
                                            type="text"
                                        />
                                        {meta.error && meta.touched && (
                                            <div className="mt-1 mb-4 text-danger">
                                                <small>{meta.error}</small>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Field>

                            <button
                                type="submit"
                                disabled={submitting}
                                className="btn btn-lg btn-block bg-warning mt-4 mb-2"
                            >
                                {submitting ? "Enviando..." : "Enviar"}
                            </button>
                        </form>
                    )}
                />
            )}
            {state.isResetConfirmation && (
                <Form
                    onSubmit={onSubmitResetConformation}
                    validate={PasswordResetConfirmationValidations}
                    render={({ handleSubmit, submitting }) => (
                        <form onSubmit={handleSubmit}>
                            <Field name="new_password1">
                                {({ input, meta }) => (
                                    <div className="form-input">
                                        <input
                                            {...input}
                                            autoComplete="off"
                                            className="form-control rounded-0 mb-3"
                                            type="password"
                                            placeholder="Nueva contraseña"
                                            onFocus={focusInput}
                                        />
                                        {meta.error && meta.touched && (
                                            <div className="mt-1 mb-2 text-danger">
                                                <small>{meta.error}</small>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Field>

                            <Field name="new_password2">
                                {({ input, meta }) => (
                                    <div className="form-input">
                                        <input
                                            {...input}
                                            autoComplete="off"
                                            className="form-control rounded-0 mb-3"
                                            type="password"
                                            placeholder="Repite contraseña"
                                            onFocus={focusInput}
                                        />
                                        {meta.error && meta.touched && (
                                            <div className="mt-1 mb-2 text-danger">
                                                <small>{meta.error}</small>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Field>

                            <button
                                type="submit"
                                disabled={submitting}
                                className="btn btn-lg btn-block bg-warning mt-4 mb-2"
                            >
                                {submitting ? "Enviando..." : "Enviar"}
                            </button>
                        </form>
                    )}
                />
            )}

            {state.message && state.message.length > 0 && (
                <ShowMessage text={state.message} />
            )}

            {state.isError && <ShowErrors arr={state.isErrorMessage} />}
        </div>
    );
};

export default PasswordReset;
